import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

export const useAndroidBackButton = () => {
  useEffect(() => {
    if (Capacitor.getPlatform() !== 'android') return;

    const backButtonListener = App.addListener('backButton', ({ canGoBack }) => {
      // A page may claim the press (e.g. to close a sheet) by listening for
      // this event and calling preventDefault(). Nobody listening = unchanged.
      const claim = new CustomEvent('sy:hardware-back', { cancelable: true });
      if (!window.dispatchEvent(claim)) return;
      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });

    return () => {
      backButtonListener.then(listener => listener.remove());
    };
  }, []);
};
